import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useGeoCountry'

import type { GeoCountryModel } from '@models/types'

const GeoCountryListItem = (props: { geoCountry: GeoCountryModel }) => {
  const {
    geoCountry,
    geoCountry: {
      code,
      id,
      title,
    },
  } = props

  const { editGeoCountryUrl } = generateUrls(geoCountry)

  return (
    <DashboardModuleListItem
      href={editGeoCountryUrl}
      secondaryText={code}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

    </DashboardModuleListItem>
  )
}

export default GeoCountryListItem
